export default "__VITE_ASSET__D79S00y9__"